// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".todesktop-platform-darwin #app:not(.full-screen) #organisation-panel .to-desktop-handle{height:30px;-webkit-app-region:drag}", ""]);
// Exports
module.exports = exports;
